import { formatDateToMMDDYYYY } from '../../../utils/dateUtils';

export const formatRemittanceCurrency = (
  value: string | null | undefined
): string => {
  if (!value) return '—';
  const amount = Number(value);
  if (Number.isNaN(amount)) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const formatRemittanceDate = (
  value: string | null | undefined
): string => (value ? formatDateToMMDDYYYY(value) : '—');
